import React from 'react'
import { useSelector } from 'react-redux';
import { SITEL_ICONS } from '../icons/sitel-icons/conf-sitel-icons';

const MIN_TEMP = -35;
const MAX_TEMP = 55;

const isValidTemp = (t) => Number.isFinite(t) && t >= MIN_TEMP && t <= MAX_TEMP;


export const GetWeatherCurrentTemp = ( {city, day} ) => {
	const data = useSelector(state => state.weather.collection)
	return (
		<>{ parseFloat(data[city]?.current?.temperature).toFixed() }</>
	)
}

// export const GetWeatherMaxTemp = ( {city, day} ) => {
// 	const data = useSelector(state => state.weather.collection)

// 	return (
// 		<>{data[city]?.forecast[day]?.updated_data !== null && data[city]?.forecast[day]?.updated_data !== undefined ? parseFloat(JSON.parse(data[city]?.forecast[day]?.updated_data)?.temp_max).toFixed() : data[city]?.forecast[day]?.data?.temp_max ? parseFloat(data[city]?.forecast[day]?.data?.temp_max).toFixed() : '0' }</>
// 	)
// }


export const GetWeatherMaxTemp = ({ city, day }) => {
	const data = useSelector(state => state.weather.collection);
	const f = data?.[city]?.forecast?.[day];

	const MIN = -30;
	const MAX = 50;

	const NEAREST = {
		"Кавадарци": ["Велес", "Прилеп", "Гевгелија", "Скопје"],
		"Прилеп": ["Крушево", "Битола", "Велес"],
		"Битола": ["Ресен", "Охрид", "Прилеп"],
		"Крушево": ["Прилеп", "Битола", "Кичево"],
		"Кичево": ["Гостивар", "Дебар", "Охрид"],
		"Дебар": ["Гостивар", "Кичево", "Охрид"],
		"Гостивар": ["Тетово", "Кичево", "Скопје"],
		"Тетово": ["Скопје", "Гостивар"],
		"Скопје": ["Тетово", "Велес", "Кратово"],
		"Велес": ["Скопје", "Кавадарци", "Штип"],
		"Крива Паланка": ["Кратово", "Скопје"],
		"Кочани": ["Штип", "Струмица"],
		"Штип": ["Кочани", "Радовиш", "Велес"],
		"Радовиш": ["Штип", "Струмица", "Гевгелија"],
		"Берово": ["Струмица", "Кочани"],
		"Струмица": ["Радовиш", "Гевгелија", "Берово"],
		"Гевгелија": ["Струмица", "Кавадарци"],
		"Ресен": ["Битола", "Охрид"],
		"Охрид": ["Ресен", "Битола", "Кичево"],
	};

	const getTemp = (c) => {
		const fc = data?.[c]?.forecast?.[day];
		if (!fc) return null;

		const raw = fc?.updated_data
			? parseFloat(JSON.parse(fc.updated_data)?.temp_max)
			: parseFloat(fc?.data?.temp_max);

		const ok = Number.isFinite(raw) && raw >= MIN && raw <= MAX;
		return ok ? raw : null;
	};

	// 1) Try requested city
	const own = getTemp(city);
	if (own !== null) return <>{own.toFixed(0)}</>;

	// 2) Try nearest cities
	const neighbors = NEAREST[city] || [];
	for (const n of neighbors) {
		const t = getTemp(n);
		if (t !== null) return <>{t.toFixed(0)}</>;
	}

	// 3) Last resort
	return <>0</>;
};


export const GetWeatherMinTemp = ( {city, day} ) => {
	const data = useSelector(state => state.weather.collection)

	return (
		<>{data[city]?.forecast[day]?.updated_data !== null && data[city]?.forecast[day]?.updated_data !== undefined ? parseFloat(JSON.parse(data[city]?.forecast[day]?.updated_data)?.temp_min).toFixed() : data[city]?.forecast[day]?.data?.temp_min ? parseFloat(data[city]?.forecast[day]?.data?.temp_min).toFixed() : '0' }</>
	)
}

export const GetWeatherIcon = ( {city, day} ) => {
	const data = useSelector(state => state.weather.collection)

	return SITEL_ICONS[data[city]?.forecast[day]?.data?.icon].link
}

export const getWeatherIcon = (data, city, day) => {
	if ( data[city]?.forecast[day]?.updated_data )
	{
		if ( JSON.parse(data[city]?.forecast[day]?.updated_data).icon )
		{
			return SITEL_ICONS[JSON.parse(data[city]?.forecast[day]?.updated_data).icon].link;
		}
	}
	
	return SITEL_ICONS[data[city]?.forecast[day]?.data?.icon]?.link !== undefined ? SITEL_ICONS[data[city]?.forecast[day]?.data?.icon]?.link : ''
}


export const getCurrentWeatherIcon = (data, city) => {
	return SITEL_ICONS[data[city]?.current?.icon]?.link !== undefined ? SITEL_ICONS[data[city]?.current?.icon]?.link : ''
}